/* eslint-disable @typescript-eslint/no-explicit-any */
import Plugin from '../plugin'

import JanusMessage from './message'

class JanusPluginMessage extends JanusMessage {
  private plugin: Plugin

  constructor(plainMessage: any, plugin: Plugin) {
    super(plainMessage)
    this.plugin = plugin
  }

  getPluginData(...names: string[]): any | null {
    return this.get('plugindata', ...['data', ...names])
  }

  getError(): any {
    const error = this.getPluginData('error')

    if (error) {
      return {
        reason: error,
        code: this.getPluginData('error_code'),
      }
    }

    return super.getError()
  }

  getResultText(): string {
    return this.getPluginData(this.plugin.getResponseAlias())
  }
}

export default JanusPluginMessage
